var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG13Visa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4235 2.89524L10.6768 2.92188L10.9115 17.1042L18.6583 17.0776L18.4235 2.89524Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1872 10.0421C11.1392 7.15755 12.4314 4.59448 14.4554 2.93195C12.9277 1.73312 11.0124 1.01222 8.93618 1.01933C4.01751 1.03618 0.105196 5.08822 0.188147 10.0798C0.271097 15.0714 4.31763 19.0962 9.2363 19.0793C11.3125 19.0722 13.2036 18.3383 14.6914 17.1291C12.6128 15.5057 11.2351 12.9267 11.1872 10.0421Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1476 9.92067C29.2306 14.9122 25.3183 18.9643 20.3996 18.9811C18.3234 18.9882 16.4081 18.2674 14.8803 17.0685C16.929 15.4059 18.1965 12.8429 18.1486 9.95834C18.1007 7.07376 16.7234 4.51983 14.6444 2.87136C16.1321 1.6622 18.0232 0.928259 20.0995 0.921148C25.0181 0.904302 29.0651 4.95417 29.1476 9.92067Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG13Visa);
export default __webpack_public_path__ + "static/media/g13_visa.5fdc47f8849b7e7d86a241968d84cf6d.svg";
export { ForwardRef as ReactComponent };